// extracted by mini-css-extract-plugin
export var actionButton = "_p9-0";
export var actionMenuContainer = "_p9-i";
export var bubble = "_p9-2";
export var bubbleActionMenu = "_p9-j";
export var bubbleContext = "_p9-6";
export var bubbleItems = "_p9-7";
export var customer = "_p9-3";
export var divider = "_p9-8";
export var fileList = "_p9-9";
export var hiddenComment = "_p9-o";
export var infoAbove = "_p9-a";
export var internal = "_p9-4";
export var lightActionButton = "_p9-1";
export var link = "_p9-b";
export var merchant = "_p9-5";
export var message = "_p9-c";
export var profilePicture = "_p9-e";
export var quillToolbarContainer = "_p9-f";
export var senderDate = "_p9-g";
export var senderDateCustomer = "_p9-h";
export var senderName = "_p9-d";
export var time = "_p9-k";
export var uploadedImage = "_p9-l";
export var username = "_p9-m";
export var xsmall = "_p9-n";